import React from 'react'
import i18n from 'i18n'

import { getEnvParam } from 'env'

import settingSVG24 from 'assets/images/nav-operations.svg'
import mailSVG24 from 'assets/images/mail.svg'

export default function getMenuList() {
  const menuList = [
    // {
    //   title: i18n.t('dashboard.title'),
    //   // title: 'Dashboard',
    //   key: 'dashboardnine',
    //   url: '/dashboard',
    //   icon: 'fe fe-home',
    // },
    {
      title: i18n.t('menu.group.operation'),
      // title: 'Dashboard',
      key: 'group1',
      icon: <img src={settingSVG24} alt={i18n.t('menu.group.operation')} />,
      children: [
        {
          title: i18n.t('workspace.title.detail'),
          // title: 'Workspace List',
          key: 'myWorkspace',
          url: '/myWorkspace',
          icon: 'fe fe-layers',
        },
        {
          title: i18n.t('appConfig.title.editDefault'),
          // title: 'Workspace List',
          key: 'appconfig',
          url: '/appconfigDefault',
          icon: 'fe fe-layers',
        },
        {
          title: i18n.t('function.title'),
          // title: 'Preset List',
          key: 'function',
          url: '/function/list',
          icon: 'fe fe-message-circle',
        },
        {
          title: i18n.t('user.title.list'),
          // title: 'User List',
          key: 'userList',
          url: '/users/list',
          icon: 'icmn fe fe-users',
        },
        // {
        //   title: i18n.t('device.title.list'),
        //   // title: 'Workspace List',
        //   key: 'deviceList',
        //   url: '/device/list',
        //   icon: 'fe fe-smartphone',
        // },

        {
          title: i18n.t('chat.title.list'),
          // title: 'Preset List',
          key: 'chatList',
          url: '/chat/list',
          icon: 'fe fe-message-circle',
        },
      ],
    },
    // {
    //   category: true,
    //   title: i18n.t('menu.category.enterpriseMaster'),
    // },
    // {
    //   title: i18n.t('enterpriseSite.title.list'),
    //   // title: 'Workspace List',
    //   key: 'enterpriseSite',
    //   url: '/enterprise-site/list',
    //   icon: 'fe fe-briefcase',
    // },
    // {
    //   divider: true,
    // },
    // {
    //   title: i18n.t('sysInfo.title.detail'),
    //   // title: 'Workspace List',
    //   key: 'systemInfo',
    //   url: '/systemInfo',
    //   icon: 'fe fe-monitor',
    // },
  ]

  const provider = getEnvParam('provider')

  if (provider != null && provider.toLowerCase() === 'officemail') {
    menuList.push({
      title: i18n.t('menu.group.email'),
      key: 'email',
      icon: <img src={mailSVG24} alt={i18n.t('menu.group.email')} />,
      children: [
        {
          title: i18n.t('onboarding.field.domain'),
          key: 'domain',
          url: '/domain/settings',
          icon: 'fe fe-layers',
        },
        {
          title: i18n.t('menu.title.mailList'),
          key: 'mailList',
          url: '/email/list',
          icon: 'fe fe-layers',
        },
        {
          title: i18n.t('menu.title.groupMail'),
          key: 'groupMail',
          url: '/groupMail',
          icon: 'icmn fe fe-users',
        },
        // {
        //   title: i18n.t('device.title.list'),
        //   // title: 'Workspace List',
        //   key: 'deviceList',
        //   url: '/device/list',
        //   icon: 'fe fe-smartphone',
        // },
      ],
    })
  }

  return menuList
}
